// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} viewBox="0 0 14.986 11.056"><path d="M5.5 11.056a1.003 1.003 0 01-.71-.297L.29 6.203a1 1 0 111.42-1.407l3.77 3.818L13.256.316a1 1 0 011.46 1.367L6.23 10.74a1.003 1.003 0 01-.717.316z"/></svg>
);

export default fn;
